// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $Channel = (tag, _1) => ({tag, _1});
const $StartPaymentResult = (tag, _1) => ({tag, _1});
const eq1 = /* #__PURE__ */ Data$dEq.eqArrayImpl(x => y => x._1 === y._1 && x._2 === y._2);
const actionIsSymbol = {reflectSymbol: () => "action"};
const fieldsIsSymbol = {reflectSymbol: () => "fields"};
const FormIsSymbol = {reflectSymbol: () => "Form"};
const urlIsSymbol = {reflectSymbol: () => "url"};
const RedirectURLIsSymbol = {reflectSymbol: () => "RedirectURL"};
const formIsSymbol = {reflectSymbol: () => "form"};
const PaymentFormIsSymbol = {reflectSymbol: () => "PaymentForm"};
const tokenIsSymbol = {reflectSymbol: () => "token"};
const ApplePayRequestTokenIsSymbol = {reflectSymbol: () => "ApplePayRequestToken"};
const P24ChannelIsSymbol = {reflectSymbol: () => "P24Channel"};
const StripeChannelIsSymbol = {reflectSymbol: () => "StripeChannel"};
const enabledIsSymbol = {reflectSymbol: () => "enabled"};
const idIsSymbol = {reflectSymbol: () => "id"};
const logoIsSymbol = {reflectSymbol: () => "logo"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const showMaybe = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const ChannelInfoIsSymbol = {reflectSymbol: () => "ChannelInfo"};
const applePayTokenIsSymbol = {reflectSymbol: () => "applePayToken"};
const blikCodeIsSymbol = {reflectSymbol: () => "blikCode"};
const cardTokenIsSymbol = {reflectSymbol: () => "cardToken"};
const channelIsSymbol = {reflectSymbol: () => "channel"};
const isIosAppIsSymbol = {reflectSymbol: () => "isIosApp"};
const PaymentRequestIsSymbol = {reflectSymbol: () => "PaymentRequest"};
const decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1);
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const genericEncodeArgsArgument = {encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)};
const encodeWithOptionsOther1 = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const genericDecodeArgsArgument = {decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(decodeWithOptionsOther), decodeSingleRecordArg: Data$dMaybe.Nothing};
const decodeWithOptionsOther1 = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.readString)};
const Form = x => x;
const RedirectURL = value0 => $StartPaymentResult("RedirectURL", value0);
const PaymentForm = value0 => $StartPaymentResult("PaymentForm", value0);
const ApplePayRequestToken = value0 => $StartPaymentResult("ApplePayRequestToken", value0);
const P24Channel = value0 => $Channel("P24Channel", value0);
const StripeChannel = /* #__PURE__ */ $Channel("StripeChannel");
const ChannelInfo = x => x;
const PaymentRequest = x => x;
const toFillFormTypeStartPaymen = {fillFormDataType: v => "unknown"};
const toFillFormTypePaymentRequ = {fillFormDataType: v => "unknown"};
const toFillFormTypeForm = {fillFormDataType: v => "unknown"};
const toFillFormTypeChannelInfo = {fillFormDataType: v => "unknown"};
const toFillFormTypeChannel = {fillFormDataType: v => "unknown"};
const newtypePaymentRequest_ = {Coercible0: () => {}};
const newtypeForm_ = {Coercible0: () => {}};
const newtypeChannelInfo_ = {Coercible0: () => {}};
const hasFieldPaymentRequest = dictHasField => dictHasField;
const hasFieldForm = dictHasField => dictHasField;
const hasFieldChannelInfo = dictHasField => dictHasField;
const eqForm = {eq: x => y => x.action === y.action && eq1(x.fields)(y.fields)};
const eqStartPaymentResult = {
  eq: x => y => {
    if (x.tag === "RedirectURL") {
      if (y.tag === "RedirectURL") { return x._1.url === y._1.url; }
      return false;
    }
    if (x.tag === "PaymentForm") {
      if (y.tag === "PaymentForm") { return x._1.form.action === y._1.form.action && eq1(x._1.form.fields)(y._1.form.fields); }
      return false;
    }
    if (x.tag === "ApplePayRequestToken") {
      if (y.tag === "ApplePayRequestToken") { return x._1.token === y._1.token; }
      return false;
    }
    return false;
  }
};
const eqChannel = {
  eq: x => y => {
    if (x.tag === "P24Channel") {
      if (y.tag === "P24Channel") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "StripeChannel") { return y.tag === "StripeChannel"; }
    return false;
  }
};
const eqChannelInfo = {
  eq: x => y => x.enabled === y.enabled && (() => {
    if (x.id.tag === "P24Channel") {
      if (y.id.tag === "P24Channel") { return x.id._1 === y.id._1; }
      return false;
    }
    if (x.id.tag === "StripeChannel") { return y.id.tag === "StripeChannel"; }
    return false;
  })() && (() => {
    if (x.logo.tag === "Nothing") { return y.logo.tag === "Nothing"; }
    if (x.logo.tag === "Just") {
      if (y.logo.tag === "Just") { return x.logo._1 === y.logo._1; }
      return false;
    }
    return false;
  })() && x.name === y.name
};
const eqPaymentRequest = {
  eq: x => y => (() => {
    if (x.applePayToken.tag === "Nothing") { return y.applePayToken.tag === "Nothing"; }
    if (x.applePayToken.tag === "Just") {
      if (y.applePayToken.tag === "Just") { return x.applePayToken._1 === y.applePayToken._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.blikCode.tag === "Nothing") { return y.blikCode.tag === "Nothing"; }
    if (x.blikCode.tag === "Just") {
      if (y.blikCode.tag === "Just") { return x.blikCode._1 === y.blikCode._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.cardToken.tag === "Nothing") { return y.cardToken.tag === "Nothing"; }
    if (x.cardToken.tag === "Just") {
      if (y.cardToken.tag === "Just") { return x.cardToken._1 === y.cardToken._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.channel.tag === "P24Channel") {
      if (y.channel.tag === "P24Channel") { return x.channel._1 === y.channel._1; }
      return false;
    }
    if (x.channel.tag === "StripeChannel") { return y.channel.tag === "StripeChannel"; }
    return false;
  })() && (() => {
    if (x.isIosApp.tag === "Nothing") { return y.isIosApp.tag === "Nothing"; }
    if (x.isIosApp.tag === "Just") {
      if (y.isIosApp.tag === "Just") { return x.isIosApp._1 === y.isIosApp._1; }
      return false;
    }
    return false;
  })()
};
const genericStartPaymentResult = {
  to: x => {
    if (x.tag === "Inl") { return $StartPaymentResult("RedirectURL", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $StartPaymentResult("PaymentForm", x._1._1); }
      if (x._1.tag === "Inr") { return $StartPaymentResult("ApplePayRequestToken", x._1._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "RedirectURL") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "PaymentForm") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "ApplePayRequestToken") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)); }
    $runtime.fail();
  }
};
const genericPaymentRequest = {to: x => x, from: x => x};
const genericForm = {to: x => x, from: x => x};
const showForm = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Data$dTuple$dT2.showT2(Data$dShow.showString)(Data$dShow.showString).show);
      return {genericShowArgs: v => ["{ action: " + Data$dShow.showStringImpl(v.action) + ", fields: " + $0(v.fields) + " " + "}"]};
    })())(FormIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const showStartPaymentResult = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ url: " + Data$dShow.showStringImpl(v.url) + " }"]})(RedirectURLIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ form: " + showForm.show(v.form) + " }"]})(PaymentFormIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ token: " + Data$dShow.showStringImpl(v.token) + " }"]})(ApplePayRequestTokenIsSymbol);
    return x => {
      const $3 = genericStartPaymentResult.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeForm = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(actionIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordCons(fieldsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Data$dTuple$dT2.udecodeT2(Unscramble.decodeString1)(Unscramble.decodeString1).unsafeDecode)
    })(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeStartPaymentResult = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(RedirectURLIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(urlIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(PaymentFormIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(formIsSymbol)(unscrambleDecodeForm)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumConstruct(ApplePayRequestTokenIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(tokenIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))))(Unscramble$dGeneric.defaultOptions);
    return x => genericStartPaymentResult.to($0(x));
  })()
};
const genericChannelInfo = {to: x => x, from: x => x};
const genericChannel = {
  to: x => {
    if (x.tag === "Inl") { return $Channel("P24Channel", x._1); }
    if (x.tag === "Inr") { return StripeChannel; }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "P24Channel") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "StripeChannel") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
    $runtime.fail();
  }
};
const showChannel = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showIntImpl(v)]})(P24ChannelIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(StripeChannelIsSymbol);
    return x => {
      if (x.tag === "P24Channel") { return $0["genericShow'"](x._1); }
      if (x.tag === "StripeChannel") { return $1["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    };
  })()
};
const showChannelInfo = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        v.enabled
          ? "{ enabled: true, id: " + showChannel.show(v.id) + ", logo: " + showMaybe.show(v.logo) + ", name: " + Data$dShow.showStringImpl(v.name) + " " + "}"
          : "{ enabled: false, id: " + showChannel.show(v.id) + ", logo: " + showMaybe.show(v.logo) + ", name: " + Data$dShow.showStringImpl(v.name) + " " + "}"
      ]
    })(ChannelInfoIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const showPaymentRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ applePayToken: " + showMaybe.show(v.applePayToken) + ", blikCode: " + showMaybe.show(v.blikCode) + ", cardToken: " + showMaybe.show(v.cardToken) + ", channel: " + showChannel.show(v.channel) + (() => {
          if (v.isIosApp.tag === "Just") {
            if (v.isIosApp._1) { return ", isIosApp: (Just true) "; }
            return ", isIosApp: (Just false) ";
          }
          if (v.isIosApp.tag === "Nothing") { return ", isIosApp: Nothing "; }
          $runtime.fail();
        })() + "}"
      ]
    })(PaymentRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeChannel = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(P24ChannelIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Unscramble.decodeInt(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(StripeChannelIsSymbol)))(Unscramble$dGeneric.defaultOptions);
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Inl") { return $Channel("P24Channel", $1._1); }
      if ($1.tag === "Inr") { return StripeChannel; }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeChannelInfo = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(enabledIsSymbol)(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons(idIsSymbol)(unscrambleDecodeChannel)(Unscramble.decodeRecordCons(logoIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(nameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodePaymentRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(applePayTokenIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(blikCodeIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(cardTokenIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(channelIsSymbol)(unscrambleDecodeChannel)(Unscramble.decodeRecordCons(isIosAppIsSymbol)(Unscramble.decodeMaybe(Unscramble.decodeBoolean1))(Unscramble.decodeRecordNil))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodeForm = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericForm)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(FormIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(fieldsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Foreign$dEncoding.defaultEncode(Data$dTuple$dT2.genericT2)(Foreign$dGeneric$dClass.genericEncodeConstructor(Data$dTuple$dT2.T2IsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsProduct(genericEncodeArgsArgument)(genericEncodeArgsArgument))));
      return {encodeWithOptions: v => encode1};
    })()))(actionIsSymbol)(encodeWithOptionsOther);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeStartPaymentResult = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericStartPaymentResult)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(RedirectURLIsSymbol)((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(urlIsSymbol)(encodeWithOptionsOther);
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(PaymentFormIsSymbol)((() => {
      const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(formIsSymbol)({encodeWithOptions: v => encodeForm.encode});
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(ApplePayRequestTokenIsSymbol)((() => {
      const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(tokenIsSymbol)(encodeWithOptionsOther);
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const encodeChannel = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericChannel)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(P24ChannelIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(StripeChannelIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        $runtime.fail();
      }
    };
  })())
};
const encodeWithOptionsOther2 = {encodeWithOptions: v => encodeChannel.encode};
const encodeChannelInfo = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericChannelInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ChannelInfoIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(nameIsSymbol)(encodeWithOptionsOther))(logoIsSymbol)(encodeWithOptionsOther1))(idIsSymbol)(encodeWithOptionsOther2))(enabledIsSymbol)({
      encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
    });
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodePaymentRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPaymentRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(PaymentRequestIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(isIosAppIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))(channelIsSymbol)(encodeWithOptionsOther2))(cardTokenIsSymbol)(encodeWithOptionsOther1))(blikCodeIsSymbol)(encodeWithOptionsOther1))(applePayTokenIsSymbol)(encodeWithOptionsOther1);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeForm = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericForm)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(FormIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(fieldsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Data$dTuple$dT2.decodeT2(genericDecodeArgsArgument)(genericDecodeArgsArgument)).decode;
    return {decodeWithOptions: v => decode2};
  })())())(actionIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeStartPaymentResult = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericStartPaymentResult)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(RedirectURLIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(urlIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PaymentFormIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(formIsSymbol)({
    decodeWithOptions: v => decodeForm.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ApplePayRequestTokenIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(tokenIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))))
};
const decodeChannel = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericChannel)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(P24ChannelIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(StripeChannelIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))
};
const decodeWithOptionsOther2 = {decodeWithOptions: v => decodeChannel.decode};
const decodeChannelInfo = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericChannelInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ChannelInfoIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(nameIsSymbol)(decodeWithOptionsOther)())(logoIsSymbol)(decodeWithOptionsOther1)())(idIsSymbol)(decodeWithOptionsOther2)())(enabledIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodePaymentRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPaymentRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PaymentRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(isIosAppIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.booleanDecode.decode)
  })())(channelIsSymbol)(decodeWithOptionsOther2)())(cardTokenIsSymbol)(decodeWithOptionsOther1)())(blikCodeIsSymbol)(decodeWithOptionsOther1)())(applePayTokenIsSymbol)(decodeWithOptionsOther1)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $Channel,
  $StartPaymentResult,
  ApplePayRequestToken,
  ApplePayRequestTokenIsSymbol,
  ChannelInfo,
  ChannelInfoIsSymbol,
  Form,
  FormIsSymbol,
  P24Channel,
  P24ChannelIsSymbol,
  PaymentForm,
  PaymentFormIsSymbol,
  PaymentRequest,
  PaymentRequestIsSymbol,
  RedirectURL,
  RedirectURLIsSymbol,
  StripeChannel,
  StripeChannelIsSymbol,
  actionIsSymbol,
  applePayTokenIsSymbol,
  blikCodeIsSymbol,
  cardTokenIsSymbol,
  channelIsSymbol,
  decodeChannel,
  decodeChannelInfo,
  decodeForm,
  decodeMaybe,
  decodePaymentRequest,
  decodeStartPaymentResult,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  decodeWithOptionsOther2,
  enabledIsSymbol,
  encodeChannel,
  encodeChannelInfo,
  encodeForm,
  encodePaymentRequest,
  encodeStartPaymentResult,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  encodeWithOptionsOther2,
  eq1,
  eqChannel,
  eqChannelInfo,
  eqForm,
  eqPaymentRequest,
  eqStartPaymentResult,
  fieldsIsSymbol,
  formIsSymbol,
  genericChannel,
  genericChannelInfo,
  genericDecodeArgsArgument,
  genericEncodeArgsArgument,
  genericForm,
  genericPaymentRequest,
  genericStartPaymentResult,
  hasFieldChannelInfo,
  hasFieldForm,
  hasFieldPaymentRequest,
  idIsSymbol,
  isIosAppIsSymbol,
  logoIsSymbol,
  nameIsSymbol,
  newtypeChannelInfo_,
  newtypeForm_,
  newtypePaymentRequest_,
  showChannel,
  showChannelInfo,
  showForm,
  showMaybe,
  showPaymentRequest,
  showStartPaymentResult,
  toFillFormTypeChannel,
  toFillFormTypeChannelInfo,
  toFillFormTypeForm,
  toFillFormTypePaymentRequ,
  toFillFormTypeStartPaymen,
  tokenIsSymbol,
  unscrambleDecodeChannel,
  unscrambleDecodeChannelInfo,
  unscrambleDecodeForm,
  unscrambleDecodePaymentRequest,
  unscrambleDecodeStartPaymentResult,
  urlIsSymbol
};
